import { Page } from 'layouts/Page';
import { HsCodesRetrieving } from 'components/HsCodesRetrieving';

export const HsCodesRetrievingPage = () => {
	return (
		<Page title="HS Codes Retrieving – EAS Control Center">
			<HsCodesRetrieving />
		</Page>
	);
};
